import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { FuncionalidadesService } from '../../../_services/funcionalidades.service';
import { ListaService } from '../../../_services/lista.service';
import { Location } from '@angular/common';
import { TerceroRiesgo } from '../../../_models/tercero-riesgo';
import { TerceroRiesgoService } from '../../../_services/tercero-riesgo.service';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { AdjuntoService } from '../../../_services/adjunto.service';
import { forkJoin } from 'rxjs';
import { TerceroService } from '../../../_services/tercero.service';
import { Tercero } from '../../../_models/tercero';

@Component( {
  selector: 'app-cambio-perfil-editar',
  templateUrl: 'cambio-perfil-editar.component.html'
} )
export class CambioPerfilEditarComponent implements OnInit {

  //
  codigos: any[] = [];

  //
  formulario: FormGroup;
  submitted = false;
  listaPerfilesRiesgos: any[] = [];
  guardando = false;
  cargandoImg = false;
  model: TerceroRiesgo = null;
  imagenPpal: any;
  imagenNueva: any;
  tercero: Tercero;


  constructor(
    private router: Router,
    private navService: NavService,
    private autServicio: AutenticacionService,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private terceroRiesgoService: TerceroRiesgoService,
    private terceroService: TerceroService,
    private perfilRiesgoService: PerfilRiesgoService,
    private funServicio: FuncionalidadesService,
    private location: Location,
    private listaService: ListaService,
    private adjuntoService: AdjuntoService,
  ) {
  }

  ngOnInit() {


    this.route.params.subscribe( ( params: Params ) => {
      if ( params[ 'id' ] !== null  || params[ 'id' ] !== undefined && params[ 'id' ] !== '' ) {
        const idTercero = params[ 'id' ];
        // Buscar información para cambiar el formulario
        this.terceroRiesgoService.obtenerHabilitadoPorTercero( idTercero ).subscribe( tercero => {
          this.cargarFormulario( tercero );

          // Buscar Lista
          this.perfilRiesgoService.listadoHabilitados()
            .subscribe( res => res.forEach( x => {
              if ( x.idPerfilRiesgo !== tercero.idPerfilRiesgo ) {
                this.listaPerfilesRiesgos.push( {
                  value: x.idPerfilRiesgo,
                  label: x.nombreRiesgo,
                  idAdjunto: x.idAdjunto,
                  img: null
                } );
              }
            } ) );
          // Buscar información del encabezado
          this.terceroService.get( tercero.idTercero )
            .subscribe( ter => this.tercero = ter );
        } );
      }
    } );

  }

  get f() {
    return this.formulario.controls;
  }

  cargarFormulario( model: TerceroRiesgo ) {
    this.model = model;
    this.formulario = this.fb.group( {
      idTerceroRiesgo: [ this.model.idTerceroRiesgo, [ Validators.required ] ],
      idTercero: [ this.model.idTercero, [ Validators.required ] ],
      idPerfilRiesgo: [ null, [ Validators.required ] ],
      observacion: [ this.model.observacion, [ Validators.maxLength( 500 ) ] ],
      indicadorCambioManual: [ true ]
    } );
    this.adjuntoService.descargarArchivo( this.model.perfilRiesgo.idAdjunto )
      .subscribe( x => {
        const reader = new FileReader();
        reader.addEventListener( 'load', () => {
          this.imagenPpal = reader.result;
        }, false );
        if ( x ) {
          reader.readAsDataURL( x );
        }
      } );
  }

  cargarImagen( id: any ) {
    const perfil = this.listaPerfilesRiesgos.find( x => x.value === id.value );
    if ( perfil && perfil.img ) {
      this.imagenNueva = perfil.img;
    } else if ( perfil && perfil.idAdjunto ) {
      this.cargandoImg = true;
      this.adjuntoService.descargarArchivo( perfil.idAdjunto ).subscribe( res => {
        const reader = new FileReader();
        reader.addEventListener( 'load', () => {
          this.imagenNueva = reader.result;
          perfil.img = this.imagenNueva;
          this.cargandoImg = false;
        }, false );
        if ( res ) {
          reader.readAsDataURL( res );
        }
      } );
    }
  }

  guardar() {
    this.submitted = true;
    if ( this.formulario.invalid ) {
      return;
    }
    this.submitted = false;

    this.confirmationService.confirm( {
      message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      key: 'cambio-perfil-editar',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.guardando = true;
        this.terceroRiesgoService.modificarRiesgo( this.formulario.value )
          .subscribe( () => {
            this.guardando = false;
            this.location.back();
          } );
      },
      reject: () => {
      }
    } );
  }


  cancelar() {
    this.location.back();
  }
}
